import { render, staticRenderFns } from "./ZibalSettings.vue?vue&type=template&id=7f00753c&scoped=true&"
import script from "./ZibalSettings.vue?vue&type=script&lang=js&"
export * from "./ZibalSettings.vue?vue&type=script&lang=js&"
import style0 from "./ZibalSettings.vue?vue&type=style&index=0&id=7f00753c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f00753c",
  null
  
)

export default component.exports